import { on, onPageLoad } from 'shared'
import { getAddressComponent } from 'shared/google_maps'
import { setAnswer as setAnswerForForm } from 'landing_pages/form/functions'
import { STATES, CA_PROVINCES } from 'lib/states'
import { bindStreetAddressAutocomplete, setupAutocomplete, unbindStreetAddressAutocomplete } from './address_autocomplete'

// FIXME: This is tied to the DOM and not compatible with icon-flow
function clearAddress() {
  setAnswerForForm('StreetAddress', '')
  setAnswerForForm('City', '')
  setAnswerForForm('State', '')
  setAnswerForForm('ZIP_Code', '')
}

function createOption(text, value, selected) {
  const option = document.createElement('option')
  option.value = value
  option.selected = selected
  option.textContent = text
  return option
}

function createPlaceholderOption(label) {
  const option = createOption(label, '', false)
  option.style.display = 'none'
  return option
}

function labelFor(element) {
  if(element.id) {
    return document.querySelector(`label[for="${element.id}"]`)
  }
}

function setStateList(labelText, options) {
  const select = document.querySelector<HTMLSelectElement>('select[name="State"]')
  if(!select) {
    return
  }

  const currentValue = select.value
  while(select.firstChild !== null) {
    select.removeChild(select.firstChild)
  }

  select.appendChild(createPlaceholderOption(labelText))
  for(let i=0; i<options.length; ++i) {
    select.appendChild(createOption(options[i].name, options[i].abbreviation, options[i].abbreviation === currentValue))
  }

  select.classList.toggle('hidden', options.length === 0)

  const label = labelFor(select)
  if(label) {
    label.textContent = labelText
  }
}

function setZIPCode(label, validation) {
  const input = document.querySelector<HTMLInputElement>('input[name="ZIP_Code"]')
  if(!input) {
    return
  }

  input.placeholder = label
  input.pattern = validation
}

function setOtherCountry(show) {
  const input = document.querySelector<HTMLInputElement>('input[name="Country"]')
  if(!input) {
    return
  }

  input.classList.toggle('hidden', !show)
  input.disabled = !show
}

let streetAddressAutocomplete: google.maps.places.Autocomplete | undefined
let countryAutocomplete: google.maps.places.Autocomplete | undefined
let componentRestrictions: google.maps.places.ComponentRestrictions = { country: ['us'] }

function setComponentRestrictions(newValue: google.maps.places.ComponentRestrictions) {
  componentRestrictions = newValue
  if(streetAddressAutocomplete) {
    streetAddressAutocomplete.setComponentRestrictions(newValue)
  }
}

onPageLoad(async () => {
  if(!window.google) return

  const streetAddressInput = document.querySelector<HTMLInputElement>('input[name="StreetAddress"]:not([data-autocomplete="false"])')
  if(streetAddressInput) {
    if(streetAddressAutocomplete) {
      unbindStreetAddressAutocomplete(streetAddressAutocomplete)
    }

    streetAddressAutocomplete = await bindStreetAddressAutocomplete(
      streetAddressInput,
      (props) => {
        for (const [key, value] of Object.entries(props)) {
          setAnswerForForm(key, value)
          const el = document.querySelector<HTMLInputElement | HTMLSelectElement>(`[name="${CSS.escape(key)}"]`)
          if (el) el.dispatchEvent(new Event('change', { bubbles: true }))
        }
      },
      { componentRestrictions }
    )
  }

  const countryInput = document.querySelector<HTMLInputElement>('input[name="Country"]:not([data-autocomplete="false"])')
  if(countryInput) {
    unbindCountryAutocomplete()
    bindCountryAutocomplete(countryInput, setAnswerForForm)
  }
})

async function bindCountryAutocomplete(countryInput, setAnswer) {
  countryAutocomplete = await setupAutocomplete(countryInput, {
    options: {
      types: ['country'],
      fields: ['address_component'],
    },
    callback: (place) => {
      setAnswer('Country', getAddressComponent(place.address_components, ['country']))
    }
  })
}

function unbindCountryAutocomplete() {
  if(countryAutocomplete) {
    countryAutocomplete.unbindAll()
  }
}

// FIXME: This is tied to the DOM and not compatible with icon-flow
on('change', 'select[name="Country"]', function(event) {
  clearAddress()

  if(event.target.value.length === 2) {
    setComponentRestrictions({ country: [event.target.value] })
  } else {
    setComponentRestrictions({ country: [] })
  }

  switch(event.target.value) {
    case 'us':
      setStateList('State', STATES)
      setZIPCode('ZIP Code', '\\d{5}')
      break
    case 'ca':
      setStateList('Province', CA_PROVINCES)
      setZIPCode('Postal Code', '[ABCEGHJ-NPRSTVXYabceghj-nprstvxy]\\d[ABCEGHJ-NPRSTV-Zabceghj-nprstv-z][ \\-]?\\d[ABCEGHJ-NPRSTV-Zabceghj-nprstv-z]\\d')
      break
    default:
      setStateList('State', [])
      setZIPCode('Postal Code', '.*')
  }

  setOtherCountry(event.target.value === 'other')
})
